import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { AdminConfirmDialogComponent } from './confirm-dialog.component';

@NgModule({
  declarations: [AdminConfirmDialogComponent],
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatProgressSpinnerModule],
  exports: [AdminConfirmDialogComponent],
})
export class AdminConfirmDialogModule {}
